export const roleIsAdmin = role => role && role.name === 'admin';
export const roleIsUser = role => role && role.name === 'user';
export const roleIsSysAdmin = role => role && role.name === 'sysadmin';
export const isSysAdmin = person => person.locations.find(loc => loc.role.name === 'sysadmin');




// WEBPACK FOOTER //
// ./src/helpers/security/roles.js